import { useEffect, useState } from 'react'

export function useDeferredFilters<T> (urlFilters: T) {
  const [ localFilters, setLocalFilters ] = useState<T>(urlFilters)

  useEffect(() => {
    setLocalFilters(urlFilters)
  }, [ urlFilters ])

  return {
    localFilters,
    setLocalFilters,
  }
}
